import { render, staticRenderFns } from "./ControleVencimento.vue?vue&type=template&id=595abb0c"
import script from "./ControleVencimento.vue?vue&type=script&lang=js"
export * from "./ControleVencimento.vue?vue&type=script&lang=js"
import style0 from "./ControleVencimento.vue?vue&type=style&index=0&id=595abb0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports